


<div  class="image-container">
    <img [src]="dealPreviewImg" style="max-width: 100%; max-height: 100%;" class="static-image">
    
    <div *ngIf="!previewFromScreen" class="image-actions">
        <button class="btn btn-primary" (click)="skipForNow()">{{regplaceHolders['MSG_ERR_PLEASE_SELETCT_CBOX']}}</button>
        <button class="btn btn-secondary" (click)="dontShowAgain()">{{regplaceHolders['MSG_ERR_IMAGE_SELECTED']}}</button>
    </div>
</div>